module.exports = __webpack_public_path__ + "assets/img/img193.96fb1b6b.png";